var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"g_id_signin",attrs:{"data-type":"standard","data-locale":_vm.$i18n.locale,"data-state":_vm.origin}})])}
var staticRenderFns = []

export { render, staticRenderFns }